var map = {
	"./avatar10.svg": 405,
	"./avatar2.svg": 428,
	"./avatar3.svg": 973,
	"./avatar4.svg": 42,
	"./avatar5.svg": 355,
	"./avatar6.svg": 960,
	"./avatar7.svg": 81,
	"./avatar8.svg": 662,
	"./avatar9.svg": 527,
	"./default-avatar.png": 272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;